import gql from "graphql-tag";

export const GET_ALL_SEQUENCE = gql`
  query {
    getAllProcessSequence {
      statusCode
      message
      data
    }
  }
`;
